import { put, call, delay } from 'redux-saga/effects';
import { Types } from './actions';
import ProceduresRepository from '../../../repositories/ProceduresRepository';
import ProceduresDataRepository from '../../../../data/repositories/ProceduresDataRepository';
import config from '../../../../core/config/config';
import XCheckpointManager from '@/core/managers/xcheckpointManager';
import { listProcedures } from '../getStudentProcedureStatus/procedure-list';

export default function* execute(action: any): any {
  const { procedureId, studentType } = action;
  try {
    yield put({ type: Types.GET_PROCEDURE_INFORMATION_REQUEST, procedureId });
    const procedure: any = listProcedures.find(
      (item: any) => item.procedureId === action.procedureId
    );
    if (procedure)
      XCheckpointManager.registerStart(`${procedure?.name} - info`);
    const proceduresRepository: ProceduresRepository =
      new ProceduresDataRepository();
    const procedureInformationResponse = yield call(
      proceduresRepository.getProcedureInformation,
      procedureId,
      studentType
    );
    if (procedure) XCheckpointManager.registerEnd(`${procedure?.name} - info`);
    if (config.DATASOURCE_ENV === 'MOCK') yield delay(1000);
    if (!procedureInformationResponse) {
      yield put({
        type: Types.GET_PROCEDURE_INFORMATION_FAILURE,
        error: 'Ha habido un problema.'
      });
      if (procedure)
        XCheckpointManager.registerEnd(`${procedure?.name} - info`);
      return;
    }

    yield put({
      type: Types.GET_PROCEDURE_INFORMATION_SUCCESS,
      data: procedureInformationResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_PROCEDURE_INFORMATION_FAILURE,
      error: 'Ha habido un problema 2.'
    });
  }
}
